import Vue from 'vue'
import VueGtm from 'vue-gtm'
import { Store } from 'vuex'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { isServer } from '@vue-storefront/core/helpers'

export const isEnabled = (gtmId: string | null) => {
  return typeof gtmId === 'string' && gtmId.length > 0 && !isServer
}

export function afterRegistration (config, store: Store<any>) {
  if (isEnabled(config.googleTagManager.id)) {
    const GTM: typeof VueGtm = (Vue as any).gtm

    const storeView = currentStoreView()
    const currencyCode = storeView.i18n.currencyCode

    const getProduct = (item) => {
      let product = {}

      const attributeMap: string[]|Record<string, any>[] = config.googleTagManager.product_attributes
      attributeMap.forEach(attribute => {
        const isObject = typeof attribute === 'object'
        let attributeField = isObject ? Object.keys(attribute)[0] : attribute
        let attributeName = isObject ? Object.values(attribute)[0] : attribute

        if (item.hasOwnProperty(attributeField) || product.hasOwnProperty(attributeName)) {
          const value = item[attributeField] || product[attributeName]
          if (value) {
            product[attributeName] = value
          }
        }
      })

      const { category } = item
      if (category && category.length > 0) {
        product['category'] = category.slice(-1)[0].name
      }

      return product
    }

    const trackRemarketing = (params) => {
      let layerParams = (window as any).dataLayer
        ?.filter(e => e.event === 'remarketing')
        ?.find(e => true)?.google_tag_params

      if (JSON.stringify(layerParams) !== JSON.stringify(params)) { // prevent duplicate events
        GTM.trackEvent({
          event: 'remarketing',
          google_tag_params: params
        });
      }
    }

    store.subscribe(({ type, payload }, state) => {
      // Adding a Product to a Shopping Cart
      if (type === 'cart/cart/ADD') {
        GTM.trackEvent({
          event: 'addToCart',
          ecommerce: {
            currencyCode: currencyCode,
            add: {
              products: [getProduct(payload.product)]
            }
          }
        });
        // state.cart.platformTotals.grand_total
        // state.cart.platformTotals.items
      }

      /* if (type === 'cart/cart/UPD_PROPS') {
      'ecomm_pagetype': 'cart',
      'ecomm_prodid': ['123A', 'H456'], // id (sku)
      'ecomm_pname': ['Nexus','Book'], // product name
      'ecomm_pcat': ['electronics', 'books'], // category
      'ecomm_pvalue': [599, 19.99], // individual product values
      'ecomm_totalvalue': '118.99' // total cart value

        console.log(state.cart?.platformTotals?.grand_total)
        console.log(state.cart.cartItems);
        debugger;
      } */

      // Removing a Product from a Shopping Cart
      if (type === 'cart/cart/DEL') {
        GTM.trackEvent({
          event: 'removeFromCart',
          ecommerce: {
            remove: {
              products: [getProduct(payload.product)]
            }
          }
        });
      }

      // Measuring Views of Product Details
      if (type === 'product/product/SET_CURRENT') {
        GTM.trackEvent({
          ecommerce: {
            detail: {
              'actionField': { 'list': '' }, // 'detail' actions have an optional list property.
              'products': [getProduct(payload)]
            }
          }
        });

        trackRemarketing({
          ecomm_pagetype: 'product',
          ecomm_prodid: [payload.sku],
          ecomm_pname: [payload.name],
          ecomm_pcat: [payload.category?.reverse()?.find(c => true)?.name]
        })
      }

      if (type === 'category-next/category/SET_CATEGORY_FILTERS') {
        trackRemarketing({
          ecomm_pagetype: 'category',
          ecomm_pcat: payload.category.name
        })
      }

      if (type === 'url/URL/SET_CURRENT_ROUTE' && payload.name === 'home') {
        trackRemarketing({
          ecomm_pagetype: 'home'
        })
      }

      // Measuring Purchases
      if (type === 'order/orders/LAST_ORDER_CONFIRMATION') {
        const orderId = payload.confirmation.backendOrderId
        const products = payload.order.products.map(product => getProduct(product))
        store.dispatch(
          'user/getOrdersHistory',
          { refresh: true, useCache: false }
        ).then(() => {
          const orderHistory = state.user.orders_history
          const order = state.user.orders_history ? orderHistory.items.find((order) => order['entity_id'].toString() === orderId) : null
          GTM.trackEvent({
            'ecommerce': {
              'purchase': {
                'actionField': {
                  'id': orderId,
                  'affiliation': order ? order.store_name : '',
                  'revenue': order ? order.total_due : state.cart.platformTotals && state.cart.platformTotals.base_grand_total ? state.cart.platformTotals.base_grand_total : '',
                  'tax': order ? order.total_due : state.cart.platformTotals && state.cart.platformTotals.base_tax_amount ? state.cart.platformTotals.base_tax_amount : '',
                  'shipping': order ? order.total_due : state.cart.platformTotals && state.cart.platformTotals.base_shipping_amount ? state.cart.platformTotals.base_shipping_amount : '',
                  'coupon': ''
                },
                'products': products
              }
            }
          })
        })
      }
    })
  }
}
